import { render, staticRenderFns } from "./cancelFeedbackModal.vue?vue&type=template&id=6ba8c43c&"
import script from "./cancelFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./cancelFeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./cancelFeedbackModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports